module.exports = __webpack_public_path__ + "img/Womens-customization-img.e5df799d.jpg";